// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c5-2";
export var aiChatCartContainerExit = "_c5-4";
export var aiChatContainerLarge = "_c5-0";
export var aiChatContainerSmall = "_c5-1";
export var aiChatIcon = "_c5-6";
export var slideInFromRight = "_c5-3";
export var slideOutToRight = "_c5-5";